import styled from '@2pulse/responsive';
import { normalize } from '@app/helpers';

// Pastille de couleur d'un état (extraite de `ServiceCard`, chantier 9c-B).
export const StatusDot = styled.View<{ color: string }>(({ props }) => ({
  width: normalize(12),
  height: normalize(12),
  borderRadius: normalize(6),
  backgroundColor: props.color,
  elevation: 2,
  shadowColor: props.color,
  shadowOffset: { width: 0, height: 2 },
  shadowOpacity: 0.6,
  shadowRadius: 4,
}));
